import { useMemo } from 'react';

import type { ApiOrgId } from '#/api/types/ApiTypedId';
import type { CartDropdownButtonOrgData } from '#/components/CartDropdownButton/CartDropdownButtonOrgData';
import {
  useUser,
  useUserEnvironmentActions,
} from '#/contexts/UserEnvironmentContext';

export function useUserEnvironmentCartDropdownButtonOrgsData(): {
  orgsCartData: CartDropdownButtonOrgData[] | undefined;
  reloadOrgsCartData: (orgId: ApiOrgId) => void;
} {
  const { fetchUserEnvironment } = useUserEnvironmentActions();
  const { user } = useUser();

  const orgsCartData = useMemo(
    () =>
      user?.orgs?.map(
        (org) =>
          ({
            id: org.id,
            name: org.name,
            itemsCount: org.cartItemCount,
          }) satisfies CartDropdownButtonOrgData,
      ),
    [user?.orgs],
  );

  const reloadOrgsCartData = fetchUserEnvironment;

  return { orgsCartData, reloadOrgsCartData };
}
